import * as React from "react";
const SvgFiRrBoltAuto = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bolt-auto_svg__a)">
      <path
        fill="#062147"
        d="m23.447 22.74-2.43-7.17c-.316-.917-1.107-1.51-2.018-1.51s-1.702.594-2.018 1.514l-2.429 7.166a1 1 0 1 0 1.894.643l.47-1.383h4.167l.47 1.383a1 1 0 0 0 1.267.626 1 1 0 0 0 .626-1.27zM17.593 20l1.281-3.78c.075-.22.177-.216.25-.003L20.406 20zM15.658 9.55a2.9 2.9 0 0 0-2.569-1.546L9.256 8l1.205-5.227c.31-1.078-.139-2.172-1.064-2.6C8.517-.233 7.532.088 6.924 1L.505 11.46a2.91 2.91 0 0 0-.163 2.997 2.9 2.9 0 0 0 2.57 1.547h3.83L5.538 21.23c-.309 1.079.14 2.172 1.064 2.6.253.117.515.174.773.174.642 0 1.267-.35 1.7-1l6.42-10.457a2.9 2.9 0 0 0 .162-2.995zm-1.843 1.91L7.451 21.827c.005-.03 1.522-6.598 1.522-6.598a1.002 1.002 0 0 0-.975-1.225H2.912a.89.89 0 0 1-.803-.483c-.077-.146-.227-.528.075-.975L8.548 2.177c-.005.029-1.522 6.599-1.522 6.599A1 1 0 0 0 8 10l5.088.004c.494 0 .726.338.803.483s.226.526-.076.973"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bolt-auto_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoltAuto;
